import {PARAMETER_HASH_HIDDEN_FRONTEND} from "@/constants/AppConstants";

export const PRODUCT_SET_TYPE = 2;

export const PRODUCT_DISCOUNT_PERCENTAGE_TYPE = 1;
export const PRODUCT_DISCOUNT_AMOUNT_TYPE = 2;
{}

export const ENERGY_CLASS_LABEL_HASH = "EURONICS_ENERGY_CLASS_LABEL";
export const ENERGY_CLASS_SHEET_HASH = "EURONICS_ENERGY_CLASS_SHEET";

export const VIDEO_PARAMETER_HASH = 'VIDEO_PARAMETER';

export const ATTACHMENT_MODEL_HASH = 'ATTACHMENT_MODEL';

export const PRODUCT_ENQUIRY_HASH = 'PRODUCT_ENQUIRY_KIND';
export const PRODUCT_VARIANT_NAME_PARAM_HASH = 'PRODUCT_VARIANT_NAME_PARAM';

export const PRODUCT_PARAMETER_BLACKLIST = [
  ENERGY_CLASS_LABEL_HASH,
  ENERGY_CLASS_SHEET_HASH,
  VIDEO_PARAMETER_HASH,
  PRODUCT_VARIANT_NAME_PARAM_HASH,
  PARAMETER_HASH_HIDDEN_FRONTEND,
];
